import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiInfo, FiExternalLink } = FiIcons;

const HeroBanner = () => {
  return (
    <div className="relative overflow-hidden bg-slate-900 border-b border-slate-800">
      {/* Background Subtle Gradient */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-yellow-500/5 to-transparent pointer-events-none" />
      
      <div className="max-w-5xl mx-auto px-4 py-12 md:py-16 relative z-10">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 space-y-6 text-center md:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-500/10 border border-yellow-500/20 text-yellow-500 text-xs font-bold uppercase tracking-wider">
              <SafeIcon icon={FiInfo} className="text-sm" />
              Community Resource
            </div>
            
            <h2 className="text-4xl md:text-5xl font-extrabold text-white leading-tight">
              Precision Brewing for <span className="text-yellow-500">Bat Coffee</span> Lovers.
            </h2>
            
            <p className="text-lg text-slate-400 max-w-2xl leading-relaxed">
              This suite of tools was built exclusively for the customers of 
              <a href="https://batcoffee.com" target="_blank" rel="noopener noreferrer" className="text-yellow-500 hover:underline mx-1">
                BatCoffee.com
              </a> 
              to ensure every pot is brewed to perfection. Free to use for all coffee enthusiasts.
            </p>

            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4">
              <a 
                href="https://batcoffee.com/collections/coffee" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-yellow-500 text-slate-950 font-bold rounded-lg hover:bg-yellow-400 transition-all shadow-lg shadow-yellow-500/10"
              >
                Shop Bat Coffee
                <SafeIcon icon={FiExternalLink} />
              </a>
            </div>
          </div>
          
          <div className="hidden lg:block w-72 h-72 rounded-2xl overflow-hidden shadow-2xl border border-slate-800 bg-white">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/00f9785630fa510c7b7249771f188009b71ad762fbad38d2b89b3733d51394c2722890c07f10237a0b5d877487ecaead/images/aW1hZ2UvanBlZw==/1b149d368d0d584d19627a7e5e5e35b6.jpeg" 
              alt="Bat Coffee Costa Rica Blend" 
              className="w-full h-full object-contain p-2 transition-transform duration-700 hover:scale-105"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;